export const membros = [
  {
    imagem: '/media/membros/Leandro.jpg',
    name: 'Leandro Alves Teodoro',
    subtitle: 'Coordenador',
    descricao: 'Professor colaborador do departamento de História do Instituto de Filosofia e Ciências Humanas da Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:leandroateodoro@uol.com.br",
    link: 'http://lattes.cnpq.br/8706720482638081'
  },
  {
    imagem: '/media/membros/rui.jpeg',
    name: 'Rui Luís Rodrigues',
    subtitle: 'Professor associado',
    descricao: 'Doutor em História Social pela Universidade de São Paulo.',
    email: "mailto:umahistoriadapeninsula@gmail.com",
    link: 'http://lattes.cnpq.br/0512724090143385'
  },
  {
    imagem: '/media/membros/AnaPaula.jpeg',
    name: 'Ana Paula Tavares Magalhães',
    subtitle: 'Professora associada',
    descricao: 'Doutorado em História Social pela Universidade de São Paulo.',
    email: "mailto:umahistoriadapeninsula@gmail.com",
    link: 'http://lattes.cnpq.br/3890004296147407'
  },
  {
    imagem: '/media/membros/Patricia.jpeg',
    name: 'Patrícia Antunes Serieiro Silva',
    subtitle: 'Apoio Técnico e Pesquisadora associada',
    descricao: 'Doutora em História Social pela Universidade de São Paulo (USP).',
    email: "mailto:pantunes@usp.br",
    link: 'http://lattes.cnpq.br/7149065470206236'
  },
  
  {
    imagem: '/media/membros/HugoB.jpeg',
    name: 'Hugo O. Bizzarri',
    subtitle: 'Professor Associado',
    descricao: 'Professor titular de Filologia Hispânica e de História das Línguas na Université de Fribourg.',
    email: "mailto:hugo.bizzarri@unifr.ch",
    link: ''
  },
  {
    imagem: '/media/membros/MariaEmilia.jpeg',
    name: 'Maria Emília Granduque José',
    subtitle: 'Pesquisadora Associada',
    descricao: 'Doutora em História Cultural pela Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:memiliagranduque@gmail.com",
    link: 'http://lattes.cnpq.br/7951231540522286'
  },
  {
    imagem: '/media/membros/CarolinaCoelho.jpeg',
    name: 'Carolina Coelho Fortes',
    subtitle: 'Professora associada',
    descricao: 'Doutorado em História pela Universidade Federal Fluminense.',
    email: "mailto:carolfortes@hotmail.com",
    link: ''
  },
  {
    imagem: '/media/membros/AnaCarolina.jpeg',
    name: 'Ana Carolina Machado de Souza',
    subtitle: 'Apoio Técnico e Pesquisadora associada',
    descricao: 'Doutoranda em História Cultural pela Universidade Estadual de Campinas.',
    email: "mailto:ana.c.m.s@hotmail.com",
    link: 'http://lattes.cnpq.br/3464932342249401'
  },
  {
    imagem: '/media/membros/Simone.jpeg',
    name: 'Simone Ferreira Gomes de Almeida',
    subtitle: 'Apoio Técnico (bolsista) e Pesquisadora associada',
    descricao: 'Doutora em História Social pela UNESP – Franca.',
    email: "mailto:simonefgalmeida@hotmail.com",
    link: 'http://lattes.cnpq.br/5883832606957231'
  },
  {
    imagem: '/media/membros/Michele.jpeg',
    name: 'Michelle Souza e Silva',
    subtitle: 'Apoio Técnico (bolsista) e Pesquisadora associada',
    descricao: 'Doutora em História, ambos pela UNESP – Franca.',
    email: "mailto:contato.sahis@gmail.com",
    link: 'http://lattes.cnpq.br/5792973791286085'
  },
  {
    imagem: '/media/membros/pedro.jpeg',
    name: 'Pedro Kanagusto',
    subtitle: 'Apoio Técnico(bolsista) e Programador',
    descricao: 'Graduado em Ciência da computação pela Universidade de Franca',
    email: "mailto:pedrokanagusto@gmail.com",
    link: ''
  },
  {
    imagem: '/media/membros/Leticiagoncalves.jpeg',
    name: 'Letícia Gonçalves Alfeu de Almeida',
    subtitle: 'Apoio Técnico e Pesquisadora associada',
    descricao: 'Doutora em História pela UNESP – Franca.',
    email: "mailto:leticiaalfeudealmeida@gmail.com",
    link: 'http://lattes.cnpq.br/0560151253508595'
  },
  {
    imagem: '/media/membros/Yasmin.jpeg',
    name: 'Yasmin de Andrade Leandro',
    subtitle: 'Pesquisadora (Mestranda)',
    descricao: 'Mestranda em História Medieval pela UNESP – Franca.',
    email: 'mailto:yasmin-leandro@hotmail.com',
    link: 'http://lattes.cnpq.br/7570544709007166'
  },
  {
    imagem: '/media/membros/Gesner.jpeg',
    name: 'Gesner Las Casas Brito Filho',
    subtitle: 'Apoio Técnico e Pesquisador associado',
    descricao: 'Doutor em História Medieval pela University of Leeds, Reino Unido (2019), com bolsa CAPES.',
    email: "mailto:gesnerlascasas@gmail.com",
    link: 'http://lattes.cnpq.br/6883595843756636'
  },
  {
    imagem: '/media/membros/Monique.jpeg',
    name: 'Monique Marques Nogueira Lima',
    subtitle: 'Apoio Técnico e Pesquisadora associada',
    descricao: 'Doutora em História e Cultura Social pela Universidade Estadual Paulista (UNESP - Franca), Doutorado sanduíche na Universidade de Lisboa.',
    email: "mailto:moniquemarqueslima@outlook.com",
    link: 'http://lattes.cnpq.br/0091097339926318'
  },
  {
    imagem: '/media/membros/Paloma.jpeg',
    name: 'Paloma Schmitz',
    subtitle: 'Aluna Associada',
    descricao: 'Graduanda em História no Instituto de Filosofia e Ciências Humanas (IFCH) da Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:p223046@dac.unicamp.br",
    link: 'http://lattes.cnpq.br/9995412587894088'
  },
  {
    imagem: '/media/membros/Livia.jpeg',
    name: 'Lívia Alves Dos Santos',
    subtitle: 'Aluna Associada',
    descricao: 'Graduanda em História no Instituto de Filosofia e Ciências Humanas (IFCH) da Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:l244716@dac.unicamp.br",
    link: 'http://lattes.cnpq.br/4738091676262766'
  },
  {
    imagem: '/media/membros/Marina.jpeg',
    name: 'Marina Luz de Carvalho',
    subtitle: 'Aluna Associada',
    descricao: 'Graduanda em História no Instituto de Filosofia e Ciências Humanas (IFCH) da Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:m184766@dac.unicamp.br",
    link: 'http://lattes.cnpq.br/4975178975050092'
  },
  {
    imagem: '/media/membros/andre.jpeg',
    name: 'André Silva Ranhel',
    subtitle: 'Aluno associado',
    descricao: 'Mestrando pelo Programa de Pós-Graduação em História da UNESP.',
    email: "mailto:andreranhel@gmail.com",
    link: 'https://www.escavador.com/sobre/4496228/andre-silva-ranhel'
  },
  {
    imagem: '/media/membros/Diovani.jpeg',
    name: 'Diovani Matheus Marques',
    subtitle: 'Aluno associado',
    descricao: 'Graduando em História no Instituto de Filosofia e Ciências Humanas (IFCH) da Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:diovanimatheus7@gmail.com",
    link: 'http://lattes.cnpq.br/9087711753141613'
  },
  {
    imagem: '/media/membros/Nicolas.jpeg',
    name: 'Nicollas Douglas De Souza Pereira',
    subtitle: 'Aluno associado',
    descricao: 'Graduando em História pela Universidade Estadual de Campinas.',
    email: "mailto:n242563@dac.unicamp.br",
    link: ''
  },
  {
    imagem: '/media/membros/LeticiaDiniz.jpeg',
    name: 'Leticia Diniz',
    subtitle: 'Aluna associada',
    descricao: 'Graduanda em História no Instituto de Filosofia e Ciências Humanas (IFCH) da Universidade Estadual de Campinas (UNICAMP).',
    email: "mailto:leticiadd@dac.unicamp.br",
    link: 'http://lattes.cnpq.br/0788485350156811'
  },
  {
    imagem: '/media/membros/Guilherme.jpeg',
    name: 'Guilherme Barbosa dos Santos',
    subtitle: 'Aluno associado',
    descricao: 'Graduando em História pela Universidade Estadual de Campinas (UNICAMP).',
    label: '',
    email: "mailto:guibarbosa294@gmail.com",
    link: 'http://lattes.cnpq.br/9357116576652272',
  },
  {

    imagem: '/media/membros/Giovanna.jpeg',
              name: 'Giovanna Mauro',
              subtitle: 'Aluna associada',
              descricao: 'Graduanda em História pela Universidade Estadual de Campinas (UNICAMP).',
              label: '',
              email: "mailto:giovannamauro@yahoo.com",
              link: '',
  },
  {
    imagem: '/media/membros/Thiago.jpeg',
              name: 'Thiago Henrique Alvarado',
              subtitle: 'Aluno associado',
              descricao: 'Mestre em História pela UNESP - Franca.',
              label: '',
              email: "mailto:thiagoalvarado@gmail.com",
              link: 'http://lattes.cnpq.br/5126326079556616',
  },
  {

    imagem: '/media/membros/Flavia.jpeg',
              name: 'Flávia Catusso Daisson Santos',
              subtitle: 'Aluna associada',
              descricao: 'Graduanda em História pela Universidade Estadual de Campinas.',
              label: '',
              email: "mailto:flavia.catusso@gmail.com",
              link: 'http://lattes.cnpq.br/9300515444830835',
  },
  {



    imagem: '/media/membros/rodrigo.jpeg',
              name: 'Rodrigo Narciso da Silva',
              subtitle: 'Aluno associado',
              descricao: 'Graduando em História na Universidade Estadual de Campinas (UNICAMP).',
              label: '',
              email: "mailto:rodrigo-n.s@hotmail.com",
              link: 'http://lattes.cnpq.br/4041247859090355',

  },
  {
    imagem: '/media/membros/FotoFilipi.jpg',
              name: 'Filipi Gomes de Souza',
              subtitle: 'Aluno associado',
              descricao: 'Graduando em História na Faculdade de Ciências e Letras da Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP - Câmpus de Assis).',
              label: '',
              email: "mailto:filipi.gomes@unesp.br",
              link: 'http://lattes.cnpq.br/8502344063526329',
  },
  {

    imagem: '/media/membros/ThiagoComelli.jpeg',
              name: 'Thiago Pereira Camargo Comelli',
              subtitle: 'Aluno associado',
              descricao: 'Graduando em História na Faculdade de Ciências e Letras da Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP - Câmpus de Assis), Bacharel em Direito pela Fundação Educacional do Município de Assis (FEMA).',
              label: '',
              email: "mailto:t.comelli@unesp.br",
              link: 'http://lattes.cnpq.br/1520524219095788',

  },
  {
    imagem: '/media/membros/AnaClara.jpg',
              name: 'Ana Clara Toledo Borges',
              subtitle: 'Aluna associada',
              descricao: 'Graduando em História na Faculdade de Ciências e Letras da Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP - Câmpus de Assis).',
              label: '',
              email: "mailto:act.borges@unesp.br",
              link: '',
  },
  {

    imagem: '/media/membros/ThiagoAugusto.jpeg',
              name: 'Thiago Augusto Motta',
              subtitle: 'Aluno associado',
              descricao: 'Graduando em História na Faculdade de Ciências e Letras (FCL) da Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP).',
              label: '',
              email: "mailto:thiago.motta@unesp.br",
              link: '',
  },
  {

    imagem: '/media/membros/YuriOmaeCamalhonte.jpeg',
              name: 'Yuri Omae Camalhonte',
              subtitle: 'Aluno associado',
              descricao: 'Graduando em História na Faculdade de Ciências e Letras da Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP - Câmpus de Assis).',
              label: '',
              email: "mailto:yuri.omae@unesp.br",
              link: 'https://wwws.cnpq.br/cvlattesweb/PKG_MENU.menu?f_cod:F56D36CE48BA22B5EDF95CFE4BBB4136#',

  },
  {

    imagem: '/media/membros/ClaudiaTrindade.jpeg',
              name: 'Cláudia Trindade de Oliveira',
              subtitle: 'Apoio Técnico e Pesquisadora associada',
              descricao: 'Formada em História e em Letras pela Universidade Estadual Paulista "Júlio de Mesquita Filho" (UNESP- campus Assis), atua em estudos voltados à religiosidade medieval e com Literatura Comparada.',
              label: '',
              email: "mailto:triclaudia@gmail.com",
              link: 'http://lattes.cnpq.br/3120482442620598',
  },
  {
    imagem: '/media/membros/EliasFeitosadeAmorimJunior.jpeg',
              name: 'Elias Feitosa de Amorim Junior',
              subtitle: 'Aluno associado',
              descricao: 'Doutorando em História da Arte Medieval na Université de Paris I (Panthéon-Sorbonne). Mestre em História da Arte-Unicamp. Bacharel e licenciado em História - USP.',
              label: '',
              email: "mailto:Elias.Feitosa-Amorim-Junior@etu.univ-paris1.fr",
              link: 'http://lattes.cnpq.br/0834644791400480',
  },
  {
    imagem: '/media/membros/MariaIzabel.jpeg',
              name: 'Maria Izabel Escano Duarte de Souza',
              subtitle: 'Aluna associado',
              descricao: 'Doutora do Programa de Pós-Graduação em História Social da USP com bolsa CAPES Mestra em História pelo Programa de Pós-Graduação em História Social da UFRJ, onde também concluiu a graduação no ano de 2012.',
              label: '',
              email: "mailto:mariaizabeleds@gmail.com",
              link: 'http://lattes.cnpq.br/9752651643175847',
  },

  {
    imagem: '/media/membros/Doglas_Lubarino.jpeg',
              name: 'Doglas Lubarino',
              subtitle: 'Aluno associado',
              descricao: 'Doutor em História pela Universidade Estadual de Campinas-UNICAMP e pela École Pratique des Hautes Études-EPHE, França.',
              label: '',
              email: "mailto:@gmail.com",
              link: 'http://lattes.cnpq.br/0742373694821923',
  },
];
